(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300),
      );
    }
  }

  customElements.define('cart-note', CartNote);

  class CartConsentStatus extends HTMLElement {
    constructor() {
      super();

      this.handleChange = this.handleChange.bind(this);
      this.updateConsentStatus = this.updateConsentStatus.bind(this);
      this.saveConsentStatus = debounce(this.saveConsentStatus.bind(this), 300);
    }

    connectedCallback() {
      this.statusInput = this.querySelector('[data-cart-consent-status-input]');
      this.legacyInput = this.querySelector('[data-cart-consent-legacy-input]');
      this.form = document.getElementById('cart');
      this.cartFooter = document.getElementById('main-cart-footer');

      if (!this.statusInput) {
        return;
      }

      this.form?.addEventListener('submit', this.updateConsentStatus);
      this.cartFooter?.addEventListener('change', this.handleChange);
      document.addEventListener('cart:sections-rendered', this.updateConsentStatus);
      document.addEventListener('cart:updated', this.updateConsentStatus);
      document.addEventListener('cart:consent-updated', this.updateConsentStatus);

      if (this.cartFooter) {
        this.observer = new MutationObserver(this.updateConsentStatus);
        this.observer.observe(this.cartFooter, { childList: true, subtree: true });
      }

      this.updateConsentStatus();
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.updateConsentStatus);
      this.cartFooter?.removeEventListener('change', this.handleChange);
      document.removeEventListener('cart:sections-rendered', this.updateConsentStatus);
      document.removeEventListener('cart:updated', this.updateConsentStatus);
      document.removeEventListener('cart:consent-updated', this.updateConsentStatus);
      this.observer?.disconnect();
    }

    handleChange(event) {
      this.updateConsentStatus();

      if (event.target?.matches('input[type="checkbox"]')) {
        this.saveConsentStatus();
      }
    }

    get consentCheckboxes() {
      const selectors = [
        '[data-cart-consent-source]',
        '[data-checkbox-assistant-cart-blocks] input[type="checkbox"]',
        '[data-checkbox-assistant-cart-actions] input[type="checkbox"]',
        '.cart__ctas input[type="checkbox"]',
      ].join(',');

      return Array.from(document.querySelectorAll(selectors)).filter((checkbox) =>
        this.isConsentCheckbox(checkbox),
      );
    }

    isConsentCheckbox(checkbox) {
      const context = checkbox.closest(
        'cart-consent-checkbox, [data-checkbox-assistant-cart-blocks], [data-checkbox-assistant-cart-actions], .main-cart-terms-conditions-disclaimer',
      );
      const labelText = checkbox.closest('label')?.textContent || '';
      const markerText = [
        checkbox.id,
        checkbox.name,
        checkbox.className,
        checkbox.getAttribute('aria-label'),
        labelText,
      ]
        .join(' ')
        .toLowerCase();

      return (
        Boolean(context) &&
        (checkbox.matches('[data-cart-consent-source]') ||
          markerText.includes('agree') ||
          markerText.includes('terms') ||
          markerText.includes('privacy') ||
          markerText.includes('consent') ||
          markerText.includes('policy') ||
          markerText.includes('同意') ||
          markerText.includes('規約'))
      );
    }

    updateConsentStatus() {
      const consentCheckboxes = this.consentCheckboxes;
      const isConsented = consentCheckboxes.some((checkbox) => checkbox.checked);
      const hasNamedCheckedSource = consentCheckboxes.some(
        (checkbox) => checkbox.checked && checkbox.name === this.statusInput.name,
      );

      this.statusInput.value = isConsented ? 'OK' : 'NG';
      this.statusInput.disabled = hasNamedCheckedSource;

      if (this.legacyInput) {
        this.legacyInput.value = '';
      }
    }

    saveConsentStatus() {
      const attributes = {
        '同意チェック': this.statusInput.disabled ? 'OK' : this.statusInput.value,
      };

      if (this.legacyInput) {
        attributes['Terms of Use accepted'] = '';
      }

      const body = JSON.stringify({ attributes });

      fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } }).catch(() => {
        const cartErrors = document.getElementById('cart-errors');

        if (cartErrors) {
          cartErrors.textContent =
            window.cartStrings?.error ||
            'There was an error while updating your cart. Please try again.';
        }
      });
    }
  }

  customElements.define('cart-consent-status', CartConsentStatus);

  class CartPhone extends HTMLElement {
    constructor() {
      super();

      this.handleInput = this.handleInput.bind(this);
      this.updateCheckoutState = this.updateCheckoutState.bind(this);
      this.savePhone = debounce(this.savePhone.bind(this), 300);
    }

    connectedCallback() {
      this.input = this.querySelector('[data-cart-phone-input]');
      this.error = this.querySelector('[data-cart-phone-error]');
      this.form = this.input ? document.getElementById(this.input.getAttribute('form')) : null;
      this.cartFooter = document.getElementById('main-cart-footer');

      if (!this.input) {
        return;
      }

      this.input.addEventListener('input', this.handleInput);
      this.input.addEventListener('change', this.handleInput);
      this.form?.addEventListener('input', this.updateCheckoutState);
      this.form?.addEventListener('change', this.updateCheckoutState);
      this.cartFooter?.addEventListener('input', this.updateCheckoutState);
      this.cartFooter?.addEventListener('change', this.updateCheckoutState);
      document.addEventListener('cart:sections-rendered', this.updateCheckoutState);
      document.addEventListener('cart:updated', this.updateCheckoutState);

      this.updateCheckoutState();
    }

    disconnectedCallback() {
      this.input?.removeEventListener('input', this.handleInput);
      this.input?.removeEventListener('change', this.handleInput);
      this.form?.removeEventListener('input', this.updateCheckoutState);
      this.form?.removeEventListener('change', this.updateCheckoutState);
      this.cartFooter?.removeEventListener('input', this.updateCheckoutState);
      this.cartFooter?.removeEventListener('change', this.updateCheckoutState);
      document.removeEventListener('cart:sections-rendered', this.updateCheckoutState);
      document.removeEventListener('cart:updated', this.updateCheckoutState);
    }

    handleInput() {
      this.updateCheckoutState();
      this.savePhone();
    }

    get checkoutButton() {
      return document.getElementById('checkout');
    }

    get isPhoneValid() {
      return /^\+?[0-9]{7,15}$/.test(this.input?.value.trim() || '');
    }

    get isCartReady() {
      return !document.getElementById('main-cart-footer')?.classList.contains('is-empty');
    }

    updateCheckoutState() {
      if (!this.input || !this.checkoutButton) {
        return;
      }

      if (window.themeSettings?.ordersPaused) {
        this.checkoutButton.disabled = true;
        this.checkoutButton.setAttribute('aria-disabled', 'true');
        return;
      }

      const isPhoneValid = this.isPhoneValid;
      const showError = this.input.value.trim() !== '' && !isPhoneValid;
      const errorMessage = this.error?.textContent.trim() || '';

      this.input.setCustomValidity(isPhoneValid ? '' : errorMessage);
      this.input.setAttribute('aria-invalid', showError ? 'true' : 'false');
      this.error?.classList.toggle('hidden', !showError);

      const isFormValid = this.form ? this.form.checkValidity() : true;
      const canCheckout = this.isCartReady && isPhoneValid && isFormValid;

      if (!canCheckout) {
        if (
          !this.checkoutButton.disabled ||
          this.checkoutButton.dataset.cartPhoneCanEnable === 'true'
        ) {
          this.checkoutButton.dataset.cartPhoneCanEnable = 'true';
        }

        this.checkoutButton.disabled = true;
        this.checkoutButton.dataset.cartPhoneDisabled = 'true';
        return;
      }

      if (this.checkoutButton.dataset.cartPhoneDisabled === 'true') {
        if (this.checkoutButton.dataset.cartPhoneCanEnable === 'true') {
          this.checkoutButton.disabled = false;
        }

        delete this.checkoutButton.dataset.cartPhoneDisabled;
        delete this.checkoutButton.dataset.cartPhoneCanEnable;
      }
    }

    savePhone() {
      const body = JSON.stringify({
        attributes: {
          'Phone number': this.input.value.trim(),
        },
      });

      fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } }).catch(() => {
        const cartErrors = document.getElementById('cart-errors');

        if (cartErrors) {
          cartErrors.textContent =
            window.cartStrings?.error ||
            'There was an error while updating your cart. Please try again.';
        }
      });
    }
  }

  customElements.define('cart-phone', CartPhone);

  } catch(e) { console.error(e); }
})();
})();
